import { Attribute, Directive, Input, TemplateRef, forwardRef } from "@angular/core";
import { ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl } from "@angular/forms";

@Directive({})
export abstract class AbstractControlValueAccessorComponent<T> implements ControlValueAccessor{

	@Input("value") value:T;
	@Input() formControlName: string;
	protected disabled:boolean;
	protected controlContainer: ControlContainer;
	static get provider():any{
		return {
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => this),
			multi: true
		}
	}
	get control():AbstractControl {
		return this.formControlName ? this.controlContainer.control.get(this.formControlName):null;
	}

	/** controlValueAccessor */
	private _onChange = (value: any) => undefined;
	public registerOnChange(fn: (value: any) => void): void { this._onChange = fn }
  
	private _onTouched = () => undefined;
	registerOnTouched(fn: () => void): void { this._onTouched = fn }
	writeValue(value: T): void {
	  this.realWriteValue(value);
	}
	protected realWriteValue(value: T){
		this.value = value as T;
	}
	setValue(value: T): void {
	  this.control.setValue(value as T);
	  this.value = value as T;
	  this.control.updateValueAndValidity();
	}
	setDisabledState(isDisabled: boolean) {
	  this.disabled = isDisabled;
	}

	_templateIsUsed(template: TemplateRef<any>): boolean {
		return template !== undefined;
	}
}